import { useEffect, useRef } from "react";
import MeetingHandler from "@/bussiness/MeetingHandler";
import IcInfo from "@/assets/svg/ic_info.svg?react";
import IcCloseToast from "@/assets/svg/ic_close_toast.svg?react";
import { toast, Id } from "react-toastify";
import React from "react";
import NoMessageHelpModal, {
  NoMessageHelpModalRef,
} from "../NoMessageHelpModal";
import recordStore from "@/store/record.store";
import timingStore, { RecordStatus } from "@/store/timing.store";

let toastId: Id;
let messageTimer: NodeJS.Timeout;
const MessageTimeout = 60 * 1000;

export default function NoMessageTip() {
  const noMessageHelpModalRef = useRef<NoMessageHelpModalRef>(null);
  const isOnline = recordStore((state) => state.isOnline);

  const handleShowModal = () => {
    noMessageHelpModalRef.current?.open();
  };

  const NoMessageContent = React.memo(() => {
    const handleHideToast = () => {
      toastId && toast.dismiss(toastId);
    };
    return (
      <div className="flex items-center justify-between">
        <div>
          无识别结果？
          <span
            className="text-#5698FF cursor-pointer"
            onClick={handleShowModal}
          >
            查看帮助
          </span>
        </div>
        <IcCloseToast
          className="ml-2 size-6 cursor-pointer"
          onClick={handleHideToast}
        />
      </div>
    );
  });

  // 无网或者恢复有网不展示
  useEffect(() => {
    toastId && toast.dismiss(toastId);
  }, [isOnline])
  

  useEffect(() => {
    const setMessageTimer = () => {
      messageTimer && clearTimeout(messageTimer);
      messageTimer = setTimeout(() => {
        // 超过1分钟没有转写结果，就出现提示
        toastId && toast.dismiss(toastId);
        if(!recordStore.getState().isOnline || timingStore.getState().recordStatus !== RecordStatus.RECORDING){
          return;
        }
        toastId = toast(<NoMessageContent />, {
          autoClose: false,
          icon: IcInfo,
        });
      }, MessageTimeout);
    };
    setMessageTimer();
    const cb = () => {
      toastId && toast.dismiss(toastId);
      setMessageTimer();
    };

    const unListenDeviceDisconnected = MeetingHandler.listenMessage(cb);
    return () => {
      toastId && toast.dismiss(toastId);
      unListenDeviceDisconnected();
    };
  }, []);

  return <NoMessageHelpModal ref={noMessageHelpModalRef} />;
}
